import EmblaCarousel from "embla-carousel";

export class Slider {
  #element;
  #node;
  #slides;
  #total;
  #current;
  #prev;
  #next;
  #embla;
  #progressBar;

  constructor(element) {
    this.#element = element;

    this.#node = this.#element.querySelector("[data-slider='slides']");

    this.#slides = this.#node.children[0].children;
    this.#total = this.#element.querySelector("[data-slider='total']");
    this.#current = this.#element.querySelectorAll("[data-slider='current']");
    this.#prev = this.#element.querySelectorAll("[data-slider='prev']");
    this.#next = this.#element.querySelectorAll("[data-slider='next']");
    this.#progressBar = null;

    const prog = this.#element.querySelector("[data-slider='progress']");

    if (prog) {
      this.#progressBar = {
        element: prog,
        bar: prog.children[0],
      };
    }

    this.#embla = EmblaCarousel(this.#node, {
      loop: true,
      align: "start",
      containScroll: "trimSnaps",
    });

    const totalSlides = this.#slides.length;
    this.#total.textContent = totalSlides.toString();

    if (this.#prev) {
      this.#prev.forEach((btn) => {
        btn.onclick = () => this.#embla.scrollPrev();
      });
    }

    if (this.#next) {
      this.#next.forEach((btn) => {
        btn.onclick = () => this.#embla.scrollNext();
      });
    }

    if (this.#progressBar) {
      this.#progressBar.bar.style.transformOrigin = `left`;
      this.#progressBar.bar.style.transition = `transform 0.55s cubic-bezier(0.33, 1, 0.68, 1)`;
    }

    const updateCurrent = () => {
      const currentIndex = this.#embla.selectedScrollSnap();
      const displayIndex = (currentIndex + 1).toString();

      if (this.#current) {
        this.#current.forEach((currentElement) => {
          currentElement.textContent = displayIndex;
        });
      }

      if (this.#progressBar && totalSlides > 0) {
        const fraction = (currentIndex + 1) / totalSlides;
        this.#progressBar.bar.style.transform = `scaleX(${fraction})`;
      }
    };

    this.#embla.on("select", updateCurrent);
    updateCurrent();
  }

  transitionOut() {
    this.#embla.destroy();
  }
}
